<template>
  <div class="yga">
    <div class="main-title">
      <h3>粤港澳大湾区高校专利有效量地域分布</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">色块颜色的深浅代表该区域所有高校专利有效量的大小，鼠标移动到该区域会显示具体的数值</div>
      </div>
    </div>
    <div class="charts map-bg">
      <echartMap mapType="yga" :isMobile="isMobile"></echartMap>
    </div>
    <div class="main-title">
      <h3>粤港澳大湾区高校专利有效量TOP10</h3>
      <!--<div class="tooltip">
        <i class="icon"></i>
        <div class="text">色块颜色的深浅代表该区域所有高校专利有效量的大小，鼠标移动到该区域会显示具体的数值</div>
      </div>-->
    </div>
    <div class="charts">
      <Echarts :height="isMobile?'230px':'650px'" :option="chartsBar"></Echarts>
    </div>
    <div class="main-title">
      <h3>粤港澳大湾区与国际三大湾区高校PCT申请量对比情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">取各大湾区所有高校的PCT公开量数据之和({{yearRange}})</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :height="isMobile?'250px':'650px'" :option="lineOption"></Echarts>
    </div>
    <div class="main-title">
      <h3>粤港澳大湾区与国际三大湾区高校PCT申请的战略性新兴产业分布情况</h3>
      <div class="tooltip">
        <i class="icon"></i>
        <div class="text">取各大湾区所有高校的公开专利在战略性新兴产业分类下的一级分类前五({{yearRange}})</div>
      </div>
    </div>
    <div class="charts">
      <Echarts :height="isMobile?'280px':'700px'" :option="polarBar"></Echarts>
    </div>
  </div>
</template>

<script>
import Query from '@/utils/query'
import Echarts from '@/components/Echarts'
import echartMap from '@/components/Map'

export default {
  name: "YGA",
  data() {
    return {
      chartsBar: {},
      lineOption: {},
      polarBar: {},
      isMobile: false
    }
  },
  mixins: [Query],
  props: {},
  components: {echartMap, Echarts},
  methods: {
    // 柱状条形图
    getChartsBar() {
      this.getAjax(6, data => {
        let yAxis = []
        let temp = []
        let WGSJ = [] // 外观设计
        let SYXX = [] // 实用新型
        let FM = [] // 发明授权
        for (let key in data) {
          const d = data[key]
          temp.push({
            name: key,
            total: d.total,
            FM: d.FM,
            SYXX: d.SYXX,
            WGSJ: d.WGSJ
          })
        }
        temp = temp.sort(function (a, b) {
          return a.total - b.total;
        })
        temp.forEach(item => {
          yAxis.push(item.name)
          WGSJ.push(item.WGSJ)
          SYXX.push(item.SYXX)
          FM.push(item.FM)
        })
        this.chartsBar = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            // data: ['外观设计', '实用新型', '发明授权']
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
          },
          grid: {
            left: '3%',
            right: '5%',
            bottom: '3%',
            top: this.isMobile?30:50,
            containLabel: true
          },
          xAxis: {
            type: 'value',
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          yAxis: {
            type: 'category',
            data: yAxis,
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          series: this.sortSeriesData([
            {
              name: '外观设计',
              type: 'bar',
              barWidth: this.isMobile?10:45,
              stack: '总量',
              label: {
                show: true,
                position: 'right',
                fontSize: this.isMobile?8:14
              },
              data: WGSJ
            },
            {
              name: '实用新型',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'insideRight',
                fontSize: this.isMobile?8:14
              },
              data: SYXX
            },
            {
              name: '发明授权',
              type: 'bar',
              stack: '总量',
              label: {
                show: true,
                position: 'insideLeft',
                fontSize: this.isMobile?8:14
              },
              data: FM
            }
          ])
        }
      })
    },
    
    // 排序由大到小
    sortSeriesData(series) {
      const sortSeriesData = series.sort((a, b) => {
        const preTotal = a.data.reduce((pre, i) => pre += i, 0)
        const afterTotal = b.data.reduce((pre, j) => pre += j, 0)
        return afterTotal - preTotal
      })
      return sortSeriesData
    },
    getLineOption() {
      this.getAjax(7, data => {
        let xAxis = []
        for (let key in data.GBA) {
          xAxis.push(key)
        }
        this.lineOption = {
          title: {},
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross',
              label: {
                backgroundColor: '#6a7985'
              }
            }
          },
          legend: {
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
          },
          grid: {
            left: '3%',
            right: '5%',
            bottom: '3%',
            containLabel: true
          },
          xAxis: [
            {
              type: 'category',
              boundaryGap: false,
              data: xAxis
            },
          ],
          yAxis: [
            {
              type: 'value'
            }
          ],
          series: this.sortSeriesData([
            {
              name: '日本东京湾区',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              data: this._format(data, 'Tokyo_Bay')
            },
            {
              name: '粤港澳大湾区',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              // data: [320, 332, 301, 334, 390, 330, 320]
              data: this._format(data, 'GBA')
            },
            {
              name: '美国旧金山湾区',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              data: this._format(data, 'San_Francisco_Bay_Area')
            },
            {
              name: '美国纽约湾区',
              type: 'line',
              stack: '总量',
              areaStyle: {},
              // data: [120, 132, 101, 134, 90, 230, 210]
              data: this._format(data, 'New_York_Bay_Area')
            }
          ])
        }
      })
    },
    _format(data, area) {
      const list = data[area]
      let temp = []
      for (let key in list) {
        temp.push(list[key])
      }
      return temp
    },
    polarDataModel(data) {
      const dataModel = new Map()
      // const xAxisNames = new Set()
      for (let key in data) {
        for (let c in data[key]) {
          const {name, value} = data[key][c]
          if(!dataModel.has(name)) {
            dataModel.set(name, [])
          }
          dataModel.get(name).push(value)
          // xAxisNames.add(name)
        }
      }
      return {
        dataModel,
        // xAxisNames: [...xAxisNames]
      }
    },
    getPolarBar() {
      this.getAjax(8, data => {
        // console.log(data)
        const namesMap = {
          GBA_PCT: '粤港澳大湾区',
          Tokyo_Bay_PCT: '日本东京湾区',
          San_Francisco_Bay_Area_PCT: '美国旧金山湾区',
          New_York_Bay_Area_PCT: '美国纽约湾区'
        }
        const {dataModel} = this.polarDataModel(data)
        const allX = Object.keys(data).reduce((pre, key) => {
          const name = namesMap[key]
          pre.push(name)
          return pre
        }, [])
        const seriesList = []
        for (const item of dataModel) {
          const [key, value] = item
          seriesList.push({
            name: key,
            type: 'bar',
            stack: 'one',
            data: value
          })
        }
        this.polarBar = {
          tooltip: {
            trigger: 'axis',
            axisPointer: {            // 坐标轴指示器，坐标轴触发有效
              type: 'shadow'        // 默认为直线，可选为：'line' | 'shadow'
            }
          },
          legend: {
            // data: ['外观设计', '实用新型', '发明授权']
            textStyle: {
              fontSize: this.isMobile?12:16
            },
            itemWidth: this.isMobile?12:25,
            itemHeight: this.isMobile?7:14
          },
          grid: {
            left: '3%',
            right: '5%',
            bottom: '3%',
            top: this.isMobile?30:50,
            containLabel: true
          },
          xAxis: {
            type: 'category',
            data: allX,
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              fontSize: this.isMobile?10:16
            }
          },
          series: seriesList
        }
        // this.polarBar = {
        //   angleAxis: {
        //     type: 'category',
        //     data: all,
        //     axisLabel: {
        //       fontSize: this.isMobile?10:16,
        //       formatter: (label) => {
        //         let str = label
        //         if (!this.isMobile && label.length > 12) {
        //           str = label.match(/.{1,12}/g).join('\n')
        //         }
        //         if (this.isMobile && label.length > 6) {
        //           str = label.match(/.{1,6}/g).join('\n')
        //         }
        //         return str

        //       }
        //     },
        //   },
        //   tooltip: {},
        //   radiusAxis: {
        //     axisLabel:{
        //       fontSize: this.isMobile?8:14
        //     }
        //   },
        //   polar: {
        //     center: ['50%',this.isMobile?'65%':'50%'],
        //     radius: this.isMobile?'45%':'80%'
        //   },
        //   series: [
        //     {
        //       type: 'bar',
        //       // data: [2, 3, 4, 3, 5, 1],
        //       data: this.getPolarBarFormat(data, 'GBA'),
        //       coordinateSystem: 'polar',
        //       name: '粤港澳大湾区'
        //     },
        //     {
        //       type: 'bar',
        //       // data: [1, 2, 3, 4, 3, 5],
        //       data: this.getPolarBarFormat(data, 'Tokyo_Bay'),
        //       coordinateSystem: 'polar',
        //       name: '日本东京湾区'
        //     },
        //     {
        //       type: 'bar',
        //       // data: [2, 4, 6, 1, 3, 2],
        //       data: this.getPolarBarFormat(data, 'San_Francisco_Bay_Area'),
        //       coordinateSystem: 'polar',
        //       name: '美国旧金山湾区'
        //     },
        //     {
        //       type: 'bar',
        //       // data: [1, 2, 3, 4, 1, 2],
        //       data: this.getPolarBarFormat(data, 'New_York_Bay_Area'),
        //       coordinateSystem: 'polar',
        //       name: '美国纽约湾区'
        //     }
        //   ],
        //   legend: {
        //     show: true,
        //     textStyle: {
        //       fontSize: this.isMobile?12:16
        //     },
        //     itemWidth: this.isMobile?12:25,
        //     itemHeight: this.isMobile?7:14
        //     // data: ['A', 'B', 'C']
        //   }
        // }
      })
    },
    getPolarBarFormat(data, area) {
      const list = data[area]
      let temp = []
      for (let key in list) {
        temp.push(list[key].value)
      }
      return temp
    }
  },
  computed: {},
  created(){
    // 判断是否移动端
    this.isMobile = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  },
  mounted() {
    this.getChartsBar()
    this.getLineOption()
    this.getPolarBar()
  }
}
</script>
